@if (waiting()) {
  <div class="tw-text-center">
    <mh-spinner-load></mh-spinner-load>
  </div>
} @else if (errorTag()) {
  <div class="tw-pt-5 tw-text-center tw-font-rubik">
    <span [innerHtml]="errorTag() | translate"></span>
    <div class="tw-py-5">
      <mh-core-lib-button
        [text]="'forms.forgot_password' | translate"
        [isPrimary]="true"
        customClass="!tw-w-auto tw-whitespace-nowrap"
        textClass="tw-font-rubik"
        (clicked)="navigateToForgotPassword()"></mh-core-lib-button>
    </div>
    <div [innerHtml]="'support.contacts.post_sale.type_1' | translate"></div>
  </div>
} @else {
  <mh-set-password-form
    [token]="token()"
    [user]="user()"
    [titleKey]="titleKey"
    [explainKey]="explainKey"></mh-set-password-form>
}

<div class="tw-pt-5 tw-text-center">
  <a class="tw-font-rubik" routerLink="/login">{{ 'forgot_password.go_home' | translate }}</a>
</div>
